import React, { Component } from 'react'
import styled from 'styled-components'

const StyledDiv = styled.div`
  color: ${props => props.theme.colors.black1};
  display: flex;
  justify-content: flex-start;
  font-weight: ${({ nest }) => (6 - nest) * 100};
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
  min-height: 0px;
  width: 100%;
  font-size: 1em;
`

const GroupName = styled.span`
  flex: 4;
  text-transform: capitalize;
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
  justify-content: flex-start;
  padding-left: 20px;
`

const ContainerDiv = styled.div`
  background-color: ${props =>
    props.nest === 0 ? props.theme.colors.grey2 : props.theme.colors.white1};
  width: 100%;
  display: flex;
  align-items: center;
  &:hover {
    background-color: ${props => props.theme.colors.grey1};
    cursor: ${props => (props.open ? 'n-resize' : 's-resize')};
  }
`

const ElementContainerDiv = styled.div`
  width: 100%;
  padding-left: 5px;
  margin-left: 5px;
  text-align: left;
  list-style: none;
`

class ElementGroup extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showChildren: false,
      children: null,
    }
    this.toggleChildren = this.toggleChildren.bind(this)
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.children !== prevState.children) {
      const { children } = nextProps
      return {
        //showChildren: ,
        showChildren: nextProps.currentlySearching
          ? React.Children.count(children) <= 2 || prevState.showChildren
          : nextProps.showChildren,
        children: nextProps.children,
      }
    } else {
      return null
    }
  }

  toggleChildren() {
    this.setState(({ showChildren, children }) => ({
      showChildren: !showChildren,
      children,
    }))
  }

  render() {
    const { props } = this
    return (
      <StyledDiv nest={props.nest}>
        <ContainerDiv onClick={this.toggleChildren} open={this.state.showChildren}>
          <GroupName>{props.name.toLowerCase()}</GroupName>
        </ContainerDiv>
        <ElementContainerDiv>{this.state.showChildren ? props.children : ''}</ElementContainerDiv>
      </StyledDiv>
    )
  }
}

export default ElementGroup
